"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DatasService", {
    enumerable: true,
    get: function() {
        return DatasService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("~/helpers/catchError");
const _dataHelpers = require("~/helpers/dataHelpers");
const _getAst = /*#__PURE__*/ _interop_require_default(require("~/helpers/getAst"));
const _PagedResponse = require("~/helpers/PagedResponse");
const _models = require("~/models");
const _utils = require("~/utils");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _constants = require("~/constants");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let DatasService = class DatasService {
    async dataList(context, param) {
        let { model, view } = param;
        if (!model) {
            const modelAndView = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
            model = modelAndView.model;
            view = modelAndView.view;
        }
        // check for linkColumnId query param and handle it
        if (param.query.linkColumnId) {
            var _linkColumn_colOptions;
            const linkColumn = await _models.Column.get(context, {
                colId: param.query.linkColumnId
            });
            if (!linkColumn || !(0, _nocodbsdk.isLinksOrLTAR)(linkColumn) || !linkColumn.colOptions || linkColumn.colOptions.fk_related_model_id !== model.id) {
                var _param_query;
                _catchError.NcError.get(context).fieldNotFound((_param_query = param.query) == null ? void 0 : _param_query.linkColumnId, {
                    customMessage: `Link column with id ${param.query.linkColumnId} not found`
                });
            }
            if ((_linkColumn_colOptions = linkColumn.colOptions) == null ? void 0 : _linkColumn_colOptions.fk_target_view_id) {
                view = await _models.View.get(context, linkColumn.colOptions.fk_target_view_id);
            }
        }
        return await this.getDataList(context, {
            model,
            view,
            query: param.query,
            throwErrorIfInvalidParams: true,
            ignorePagination: param.ignorePagination,
            limitOverride: param.limitOverride,
            getHiddenColumns: param.getHiddenColumns,
            apiVersion: param.apiVersion,
            includeSortAndFilterColumns: param.includeSortAndFilterColumns,
            includeRowColorColumns: param.includeRowColorColumns,
            includeButtonFilterColumns: param.includeButtonFilterColumns,
            ignoreViewFilterAndSort: param.ignoreViewFilterAndSort,
            baseModel: param.baseModel
        });
    }
    async dataFindOne(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        return await this.getFindOne(context, {
            model,
            view,
            query: param.query
        });
    }
    async dataGroupBy(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        return await this.getDataGroupBy(context, {
            model,
            view,
            query: param.query
        });
    }
    async dataGroupByCount(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        return await this.getDataGroupByCount(context, {
            model,
            view,
            query: param.query
        });
    }
    async dataCount(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const countArgs = _extends({}, param.query, {
            throwErrorIfInvalidParams: true
        });
        try {
            countArgs.filterArr = JSON.parse(countArgs.filterArrJson);
        } catch (e) {}
        const count = await baseModel.count(countArgs);
        return {
            count
        };
    }
    async dataInsert(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        return await baseModel.nestedInsert(param.body, param.cookie, null, param == null ? void 0 : param.query);
    }
    async dataUpdate(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        return await baseModel.updateByPk(param.rowId, param.body, null, param.cookie, param.disableOptimization);
    }
    async dataDelete(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        // if xcdb base skip checking for LTAR
        if (!source.isMeta()) {
            const message = await baseModel.hasLTARData(param.rowId, model);
            if (message.length) {
                _catchError.NcError.get(context).badRequest(message);
            }
        }
        return await baseModel.delByPk(param.rowId, null, param.cookie);
    }
    async getDataList(context, param) {
        const { model, view: view, query = {}, ignoreViewFilterAndSort = false, includeSortAndFilterColumns = false, skipSortBasedOnOrderCol = false, apiVersion } = param;
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = param.baseModel || await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const { ast, dependencyFields } = await (0, _getAst.default)(context, {
            model,
            query,
            view: view,
            throwErrorIfInvalidParams: param.throwErrorIfInvalidParams,
            getHiddenColumn: param.getHiddenColumns,
            apiVersion,
            includeSortAndFilterColumns: includeSortAndFilterColumns,
            includeRowColorColumns: param.includeRowColorColumns,
            includeButtonFilterColumns: param.includeButtonFilterColumns,
            skipSubstitutingColumnIds: (query == null ? void 0 : query[_constants.QUERY_STRING_FIELD_ID_ON_RESULT]) === 'true'
        });
        const listArgs = dependencyFields;
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        listArgs.customConditions = param.customConditions;
        const [count, data] = await Promise.all([
            baseModel.count(listArgs, false, param.throwErrorIfInvalidParams),
            (async ()=>{
                let data = [];
                try {
                    data = await (0, _utils.nocoExecute)(ast, await baseModel.list(_extends({}, listArgs, {
                        apiVersion: param.apiVersion
                    }), {
                        ignoreViewFilterAndSort,
                        throwErrorIfInvalidParams: param.throwErrorIfInvalidParams,
                        ignorePagination: param.ignorePagination,
                        limitOverride: param.limitOverride,
                        skipSubstitutingColumnIds: context.api_version === _nocodbsdk.NcApiVersion.V3 && (query == null ? void 0 : query[_constants.QUERY_STRING_FIELD_ID_ON_RESULT]) === 'true',
                        skipSortBasedOnOrderCol
                    }), {}, listArgs);
                } catch (e) {
                    if (e instanceof _catchError.NcBaseError || e instanceof _nocodbsdk.NcSDKErrorV2) throw e;
                    this.logger.error('Error fetching data', e);
                    _catchError.NcError.get(context).internalServerError('Please check server log for more details');
                }
                return data;
            })()
        ]);
        return new _PagedResponse.PagedResponseImpl(data, _extends({}, query, param.limitOverride ? {
            limitOverride: param.limitOverride
        } : {}, {
            count
        }));
    }
    async getFindOne(context, param) {
        const { model, view, query = {} } = param;
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const args = _extends({}, query);
        try {
            args.filterArr = JSON.parse(args.filterArrJson);
        } catch (e) {}
        try {
            args.sortArr = JSON.parse(args.sortArrJson);
        } catch (e) {}
        const { ast, dependencyFields } = await (0, _getAst.default)(context, {
            model,
            query: args,
            view
        });
        const data = await baseModel.findOne(_extends({}, args, dependencyFields));
        return data ? await (0, _utils.nocoExecute)(ast, data, {}, dependencyFields) : {};
    }
    async getDataGroupBy(context, param) {
        const { model, view, query = {} } = param;
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const listArgs = _extends({}, query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        const data = await baseModel.groupBy(listArgs);
        const count = await baseModel.groupByCount(listArgs);
        return new _PagedResponse.PagedResponseImpl(data, _extends({}, query, {
            count
        }));
    }
    async getDataGroupByCount(context, param) {
        const { model, view, query = {} } = param;
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const listArgs = _extends({}, query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        return await baseModel.groupByCount(listArgs);
    }
    async dataRead(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const row = await baseModel.readByPk(param.rowId, false, param.query, {
            getHiddenColumn: param.getHiddenColumn
        });
        if (!row) {
            _catchError.NcError.get(context).recordNotFound(param.rowId);
        }
        return row;
    }
    async dataExist(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        return await baseModel.exist(param.rowId);
    }
    // todo: Handle the error case where view doesnt belong to model
    async groupedDataList(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        const groupedData = await this.getGroupedDataList(context, {
            model,
            view,
            query: param.query,
            columnId: param.columnId
        });
        return groupedData;
    }
    async getGroupedDataList(context, param) {
        var _param_query;
        const { model, view, query = {} } = param;
        const source = await _models.Source.get(context, model.source_id);
        // Use singleQueryGroupedList for PostgreSQL to avoid nocoExecute
        // It handles nested columns/rollups directly in SQL
        if (source.type === 'pg' && ((_param_query = param.query) == null ? void 0 : _param_query.opt) === 'true') {
            const { dependencyFields } = await (0, _getAst.default)(context, {
                model,
                query,
                view,
                includeRowColorColumns: query.include_row_color === 'true',
                includeButtonFilterColumns: query.include_button_filter_columns === 'true'
            });
            const listArgs = _extends({}, dependencyFields);
            try {
                listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
            } catch (e) {}
            try {
                listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
            } catch (e) {}
            try {
                listArgs.options = JSON.parse(listArgs.optionsArrJson);
            } catch (e) {}
            const baseModel = await _models.Model.getBaseModelSQL(context, {
                id: model.id,
                viewId: view == null ? void 0 : view.id,
                dbDriver: await _NcConnectionMgrv2.default.get(source),
                source
            });
            // Run both queries in parallel for better performance
            const [groupedData, countArr] = await Promise.all([
                await baseModel.groupedList(_extends({}, listArgs, {
                    groupColumnId: param.columnId
                })),
                baseModel.groupedListCount(_extends({}, listArgs, {
                    groupColumnId: param.columnId
                }))
            ]);
            return groupedData.map((item)=>{
                var _ref;
                var _countArr_find;
                const count = (_ref = (_countArr_find = countArr.find((countItem)=>countItem.key === item.key)) == null ? void 0 : _countArr_find.count) != null ? _ref : 0;
                return _extends({}, item, {
                    value: new _PagedResponse.PagedResponseImpl(item.value, _extends({}, query, {
                        count: count
                    }))
                });
            });
        }
        // Fallback to original implementation for non-PostgreSQL databases
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const { ast, dependencyFields } = await (0, _getAst.default)(context, {
            model,
            query: _extends({}, query),
            view,
            includeRowColorColumns: (query == null ? void 0 : query.include_row_color) === 'true',
            includeButtonFilterColumns: (query == null ? void 0 : query.include_button_filter_columns) === 'true'
        });
        const listArgs = _extends({}, dependencyFields);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        try {
            listArgs.options = JSON.parse(listArgs.optionsArrJson);
        } catch (e) {}
        let data = [];
        const groupedData = await baseModel.groupedList(_extends({}, listArgs, {
            groupColumnId: param.columnId,
            includeRowColorColumns: (query == null ? void 0 : query.include_row_color) === 'true',
            includeButtonFilterColumns: (query == null ? void 0 : query.include_button_filter_columns) === 'true'
        }));
        data = await (0, _utils.nocoExecute)({
            key: 1,
            value: ast
        }, groupedData, {}, listArgs);
        const countArr = await baseModel.groupedListCount(_extends({}, listArgs, {
            groupColumnId: param.columnId
        }));
        data = data.map((item)=>{
            var _ref;
            var _countArr_find;
            // todo: use map to avoid loop
            const count = (_ref = (_countArr_find = countArr.find((countItem)=>countItem.key === item.key)) == null ? void 0 : _countArr_find.count) != null ? _ref : 0;
            item.value = new _PagedResponse.PagedResponseImpl(item.value, _extends({}, query, {
                count: count
            }));
            return item;
        });
        return data;
    }
    async dataListByViewId(context, param) {
        const view = await _models.View.get(context, param.viewId);
        const model = await _models.Model.getByIdOrName(context, {
            id: (view == null ? void 0 : view.fk_model_id) || param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound((view == null ? void 0 : view.fk_model_id) || param.viewId);
        return await this.getDataList(context, {
            model,
            view,
            query: param.query,
            apiVersion: param.apiVersion
        });
    }
    async mmList(context, param) {
        var _this;
        const view = await _models.View.get(context, param.viewId);
        const model = await _models.Model.getByIdOrName(context, {
            id: (view == null ? void 0 : view.fk_model_id) || param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound((view == null ? void 0 : view.fk_model_id) || param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const key = `${model.title}List`;
        const requestObj = {
            [key]: 1
        };
        const data = (_this = await (0, _utils.nocoExecute)(requestObj, {
            [key]: async (args)=>{
                return await baseModel.mmList({
                    colId: param.colId,
                    parentId: param.rowId
                }, args);
            }
        }, {}, {
            nested: {
                [key]: param.query
            }
        })) == null ? void 0 : _this[key];
        const count = await baseModel.mmListCount({
            colId: param.colId,
            parentId: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async mmExcludedList(context, param) {
        var _this;
        const view = await _models.View.get(context, param.viewId);
        const model = await _models.Model.getByIdOrName(context, {
            id: (view == null ? void 0 : view.fk_model_id) || param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound((view == null ? void 0 : view.fk_model_id) || param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const key = 'List';
        const requestObj = {
            [key]: 1
        };
        const data = (_this = await (0, _utils.nocoExecute)(requestObj, {
            [key]: async (args)=>{
                return await baseModel.getMmChildrenExcludedList({
                    colId: param.colId,
                    pid: param.rowId
                }, args);
            }
        }, {}, {
            nested: {
                [key]: param.query
            }
        })) == null ? void 0 : _this[key];
        const count = await baseModel.getMmChildrenExcludedListCount({
            colId: param.colId,
            pid: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async hmExcludedList(context, param) {
        var _this;
        const view = await _models.View.get(context, param.viewId);
        const model = await _models.Model.getByIdOrName(context, {
            id: (view == null ? void 0 : view.fk_model_id) || param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound((view == null ? void 0 : view.fk_model_id) || param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const key = 'List';
        const requestObj = {
            [key]: 1
        };
        const data = (_this = await (0, _utils.nocoExecute)(requestObj, {
            [key]: async (args)=>{
                return await baseModel.getHmChildrenExcludedList({
                    colId: param.colId,
                    pid: param.rowId
                }, args);
            }
        }, {}, {
            nested: {
                [key]: param.query
            }
        })) == null ? void 0 : _this[key];
        const count = await baseModel.getHmChildrenExcludedListCount({
            colId: param.colId,
            pid: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async btExcludedList(context, param) {
        var _this;
        const view = await _models.View.get(context, param.viewId);
        const model = await _models.Model.getByIdOrName(context, {
            id: (view == null ? void 0 : view.fk_model_id) || param.viewId
        });
        if (!model) return _catchError.NcError.get(context).tableNotFound((view == null ? void 0 : view.fk_model_id) || param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const key = 'List';
        const requestObj = {
            [key]: 1
        };
        const data = (_this = await (0, _utils.nocoExecute)(requestObj, {
            [key]: async (args)=>{
                return await baseModel.getBtChildrenExcludedList({
                    colId: param.colId,
                    cid: param.rowId
                }, args);
            }
        }, {}, {
            nested: {
                [key]: param.query
            }
        })) == null ? void 0 : _this[key];
        const count = await baseModel.getBtChildrenExcludedListCount({
            colId: param.colId,
            cid: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async hmList(context, param) {
        var _this;
        const view = await _models.View.get(context, param.viewId);
        const model = await _models.Model.getByIdOrName(context, {
            id: (view == null ? void 0 : view.fk_model_id) || param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound((view == null ? void 0 : view.fk_model_id) || param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const key = `${model.title}List`;
        const requestObj = {
            [key]: 1
        };
        const data = (_this = await (0, _utils.nocoExecute)(requestObj, {
            [key]: async (args)=>{
                return await baseModel.hmList({
                    colId: param.colId,
                    id: param.rowId
                }, args);
            }
        }, {}, {
            nested: {
                [key]: param.query
            }
        })) == null ? void 0 : _this[key];
        const count = await baseModel.hmListCount({
            colId: param.colId,
            id: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, {
            totalRows: count
        });
    }
    async dataReadByViewId(context, param) {
        try {
            const model = await _models.Model.getByIdOrName(context, {
                id: param.viewId
            });
            if (!model) _catchError.NcError.get(context).tableNotFound(param.viewId);
            const source = await _models.Source.get(context, model.source_id);
            const baseModel = await _models.Model.getBaseModelSQL(context, {
                id: model.id,
                dbDriver: await _NcConnectionMgrv2.default.get(source),
                source
            });
            const { ast, dependencyFields } = await (0, _getAst.default)(context, {
                model,
                query: param.query
            });
            return await (0, _utils.nocoExecute)(ast, await baseModel.readByPk(param.rowId, false), {}, dependencyFields);
        } catch (e) {
            if (e instanceof _catchError.NcError || e instanceof _catchError.NcBaseError) throw e;
            this.logger.error('Please check server log for more details', e);
            _catchError.NcError.get(context).internalServerError('Please check server log for more details');
        }
    }
    async dataInsertByViewId(context, param) {
        const model = await _models.Model.getByIdOrName(context, {
            id: param.viewId
        });
        if (!model) return _catchError.NcError.get(context).tableNotFound(param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        return await baseModel.insert(param.body, null, param.cookie);
    }
    async dataUpdateByViewId(context, param) {
        const model = await _models.Model.getByIdOrName(context, {
            id: param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound(param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        return await baseModel.updateByPk(param.rowId, param.body, null, param.cookie);
    }
    async dataDeleteByViewId(context, param) {
        const model = await _models.Model.getByIdOrName(context, {
            id: param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound(param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        return await baseModel.delByPk(param.rowId, null, param.cookie);
    }
    async relationDataDelete(context, param) {
        const view = await _models.View.get(context, param.viewId);
        const model = await _models.Model.getByIdOrName(context, {
            id: (view == null ? void 0 : view.fk_model_id) || param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound((view == null ? void 0 : view.fk_model_id) || param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        await baseModel.removeChild({
            colId: param.colId,
            childId: param.childId,
            rowId: param.rowId,
            cookie: param.cookie
        });
        return true;
    }
    async relationDataAdd(context, param) {
        const view = await _models.View.get(context, param.viewId);
        const model = await _models.Model.getByIdOrName(context, {
            id: (view == null ? void 0 : view.fk_model_id) || param.viewId
        });
        if (!model) _catchError.NcError.get(context).tableNotFound((view == null ? void 0 : view.fk_model_id) || param.viewId);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        await baseModel.addChild({
            colId: param.colId,
            childId: param.childId,
            rowId: param.rowId,
            cookie: param.cookie
        });
        return true;
    }
    async getViewAndModelFromRequestByAliasOrId(context, req) {
        var _req_params_baseId;
        const base = await _models.Base.getWithInfoByTitleOrId(context, (_req_params_baseId = req.params.baseId) != null ? _req_params_baseId : req.params.baseName);
        const model = await _models.Model.getByAliasOrId(context, {
            base_id: base.id,
            aliasOrId: req.params.tableName
        });
        const view = req.params.viewName && await _models.View.getByTitleOrId(context, {
            titleOrId: req.params.viewName,
            fk_model_id: model.id
        });
        if (!model) _catchError.NcError.get(context).tableNotFound(req.params.tableName);
        return {
            model,
            view
        };
    }
    async getColumnByIdOrName(context, columnNameOrId, model) {
        const column = (await model.getColumns(context)).find((c)=>c.title === columnNameOrId || c.id === columnNameOrId || c.column_name === columnNameOrId);
        if (!column) _catchError.NcError.get(context).fieldNotFound(columnNameOrId);
        return column;
    }
    constructor(){
        this.logger = new _common.Logger(DatasService.name);
    }
};
DatasService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [])
], DatasService);
